import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface HomeHeaderProps {
  notificationCount: number | null;
  onNotificationClick?: () => void;
}

const ROBOT_AVATAR = 'https://readdy.ai/api/search-image?query=A%20cute%20friendly%20round%20robot%20avatar%20icon%20for%20AI%20trading%20app%2C%20soft%20purple%20and%20blue%20gradient%20colors%2C%20minimalist%203D%20style%2C%20smooth%20rounded%20shapes%2C%20glowing%20eyes%2C%20light%20tech%20aesthetic%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20high%20quality%20render&width=120&height=120&seq=robot_avatar_01&orientation=squarish';

export default function HomeHeader({
  notificationCount,
  onNotificationClick,
}: HomeHeaderProps) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isLoggedIn = !!user;

  const handleAvatarClick = () => {
    if (!isLoggedIn) {
      navigate('/auth?redirect=%2F');
      return;
    }
    navigate('/profile');
  };

  const displayName = isLoggedIn
    ? (user?.user_metadata?.full_name as string || 'Dev Tester')
    : '请先登录';


  return (
    <div
      className="relative"
      style={{
        paddingTop: 'max(env(safe-area-inset-top, 0px), 48px)',
        paddingBottom: '28px',
        background: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 60%, #818CF8 100%)',
      }}
    >
      {/* ── Top row: avatar + greeting + bell ── */}
      <div className="flex items-start justify-between px-5">
        <div className="flex items-start gap-3">
          {/* Avatar */}
          <button onClick={handleAvatarClick} className="relative flex-shrink-0">
            <img
              src={ROBOT_AVATAR}
              alt="AI"
              className="w-10 h-10 rounded-full object-cover"
              style={{ border: '2px solid rgba(255,255,255,0.25)' }}
            />
          </button>

          {/* Greeting + Mode tag stacked */}
          <div className="flex flex-col gap-1.5 pt-0.5">
            <span className="text-white font-medium text-[15px] leading-tight">
              你好，{displayName} 👋
            </span>
            <span className="self-start rounded border border-white/20 bg-white/15 px-1.5 py-0.5 text-[10px] leading-tight text-white/80">
              账户概览
            </span>
          </div>
        </div>

        {/* Notification bell */}
        <button
          onClick={onNotificationClick}
          className="relative flex-shrink-0 w-9 h-9 flex items-center justify-center active:scale-90 transition-transform"
        >
          <i className="ri-notification-3-line text-white text-[22px]" />
          {notificationCount != null && notificationCount > 0 && (
            <span
              className="absolute top-0 right-0 w-2.5 h-2.5 rounded-full bg-red-500"
              style={{ border: '2px solid #4F46E5' }}
            />
          )}
        </button>
      </div>

      {/* ── Status area ── */}
      <div className="px-5 mt-5">
        {/* Title + status badge */}
        <div className="flex items-center gap-2">
          <span className="text-white text-[16px] font-medium">
            账户与跟随概览
          </span>

        </div>

        {/* Subtitle */}
        <div className="flex items-center gap-0.5 mt-1.5">
          <span className="text-white/60 text-[13px]">
            未读消息 {notificationCount ?? '—'}
          </span>
          <i className="ri-arrow-right-s-line text-white/40 text-sm" />
        </div>
      </div>
    </div>
  );
}
